export class OrganizationEmailSettingsModel {
    constructor() {}

    organizationId: number;
    dailyQuota: number;
    dailyCounter: number;
    lastEmail?: Date;
    isAllowExternalRecipients: boolean;
}
